import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { AUTH_TOKEN, AUTH_USER } from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import { message } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      /* const response = await FirebaseService.signInEmailRequest(
        email,
        password
      ); */
      //console.log("REACT_APP_API_URI", process.env.REACT_APP_API_URI);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/v1/auth/login`,
        {
          email,
          password,
        }
      );
      if (response.data.success) {
        const token = response.data.result.token;
        localStorage.setItem(AUTH_TOKEN, token);
        localStorage.setItem(
          AUTH_USER,
          JSON.stringify(response.data.result.user)
        );
        message.success("Sign-in successful!");
        return token;
      } else {
        const errorMessage = response.message?.replace("Firebase: ", "");
        message.error(errorMessage || "Sign-in failed!");
        return rejectWithValue(errorMessage);
      }
    } catch (err) {
      const errorMessage = err.response.data.message || "Error";
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const signUp = createAsyncThunk(
  "auth/signUp",
  async (data, { rejectWithValue }) => {
    //const { userType } = useParams();
    const {
      firstName,
      middleName,
      lastName,
      aadharNo,
      mobileNo,
      email,
      isProprietorOrRepresentative,
      unitPanNo,
      unitGstIn,
      unitName,
      IEC,
      IECAddress,
      branchAddress,
      unitEmailId,
      businessType,
      commodity,
      password,
      confirmPassword,
      userType,
    } = data;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/v1/auth/register/${userType}`,
        {
          firstName,
          middleName,
          lastName,
          aadharNo,
          mobileNo,
          email,
          isProprietorOrRepresentative,
          unitDetails: {
            unitPanNo,
            unitGstIn,
            unitName,
            IEC,
            IECAddress,
            branchAddress,
            unitEmailId,
            businessType,
            commodity,
          },
          password,
          confirmPassword,
        }
      );
      if (response.data.success) {
        rejectWithValue("");
        message.success(response.data.message);
        console.log("response.data", response.data);
        return response.data;
      } else {
        message.error(response.data.message);
        return rejectWithValue(response.message?.replace("Firebase: ", ""));
      }
    } catch (err) {
      message.error(err.response.data.message);
      return rejectWithValue(err.response.data.message || "Error");
    }
  }
);

export const signOut = createAsyncThunk("auth/signOut", async () => {
  const response = await FirebaseService.signOutRequest();
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(AUTH_USER);
  return response.data;
});

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInGoogleRequest();
    if (response.user) {
      const token = response.user.refreshToken;
      localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
      return token;
    } else {
      return rejectWithValue(response.message?.replace("Firebase: ", ""));
    }
  }
);

export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInFacebookRequest();
    if (response.user) {
      const token = response.user.refreshToken;
      localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
      return token;
    } else {
      return rejectWithValue(response.message?.replace("Firebase: ", ""));
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithFacebook.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signInWithFacebook.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
